/**
 * 区分当前设备
 */

const device = {
  state: {
    isMobile: true
  },
  mutations: {
    TOGGLE_DEVICE(state, value) {
      state.isMobile = value
    }
  },
  actions: {
    toggleDevice({ commit }, value) {
      commit('TOGGLE_DEVICE', value)
    }
  }
};

export default device
